const VIEWED_CLIPS_KEY = "viewedClipIds";
const MAX_VIEWED_CLIPS = 1000;

export const getViewedClips = (): string[] => {
  try {
    const stored = localStorage.getItem(VIEWED_CLIPS_KEY);
    if (!stored) {
      return [];
    }
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Error reading viewed clips from localStorage:", error);
    return [];
  }
};

export const addViewedClip = (clipId: string): void => {
  if (!clipId) {
    return;
  }

  try {
    const viewedClips = getViewedClips();

    if (viewedClips.includes(clipId)) {
      return;
    }

    viewedClips.push(clipId);

    if (viewedClips.length > MAX_VIEWED_CLIPS) {
      const excessCount = viewedClips.length - MAX_VIEWED_CLIPS;
      viewedClips.splice(0, excessCount);
    }

    localStorage.setItem(VIEWED_CLIPS_KEY, JSON.stringify(viewedClips));
  } catch (error) {
    console.error("Error adding viewed clip to localStorage:", error);
  }
};

export const clearViewedClips = (): void => {
  try {
    localStorage.removeItem(VIEWED_CLIPS_KEY);
  } catch (error) {
    console.error("Error clearing viewed clips from localStorage:", error);
  }
};

export const getViewedClipsCount = (): number => {
  return getViewedClips().length;
};
